import { css } from "@compiled/react";

import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";
import {
    Headings,
    ReturnToProductText,
    WelcomeBackText
} from "../../../components";

export const CurrentProductUser = () => {
    return (
        <ConfluenceOverlayTemplate size="sm">
            <div css={containerCss}>
                <Headings
                    main={<WelcomeBackText />}
                    sub={<ReturnToProductText />}
                />
                <SiteActivation
                    CurrentProductUser={<ReturnToProduct />}
                    useContactExpandCohortLogic={true}
                />
            </div>
        </ConfluenceOverlayTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
